import { ReactNode } from 'react';
import { styled } from '@mui/joy';

export interface SquaredBadgeProps {
  children: ReactNode;
  className?: string;
}

export const SquaredBadge = ({ children, className }: SquaredBadgeProps) => {
  return <SquaredBadgeContainer className={className}>{children}</SquaredBadgeContainer>;
};

const SquaredBadgeContainer = styled('div')(({ theme: { palette } }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Roboto, sans-serif',
  backgroundColor: palette.blueLight,
  color: palette.bluePrimary,
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '12px',
  paddingTop: '3px',
  paddingRight: '6px',
  paddingBottom: '3px',
  paddingLeft: '6px',
  borderRadius: '3px',
  opacity: 1,
  gap: '4px',
  alignSelf: 'flex-start',
  width: 'fit-content',
}));
